
const { lazy } = require('react');

function populate(source) {
  const results = [];

  source.forEach(item => {
    const title = item.section;
    const [result] = results.filter(m => m.title === title);

    if (result) {
      result.links.push(item);
    } else {
      results.push({
        title,
        links: [item],
      });
    }
  });

  return results;
}


module.exports = function (api) {
  const sitemap = {
    "general": {
      "title": undefined,
      "sections": [...populate([
  {
    id: "01-Basics",
    route: "/general/css/01-Basics",
    title: "Getting Started",
    link: "/general/css/01-Basics",
    section: "AngleSharp.Css",
    meta: {"title":"Getting Started","section":"AngleSharp.Css"},
    page: lazy(() => import('../tools/__generated__/css-01-Basics.tsx')),
  }, 
  {
    id: "02-Values",
    route: "/general/css/02-Values",
    title: "Types of Values",
    link: "/general/css/02-Values",
    section: "AngleSharp.Css",
    meta: {"title":"Types of Values","section":"AngleSharp.Css"},
    page: lazy(() => import('../tools/__generated__/css-02-Values.tsx')),
  }])],
    },"docs": {
      "title": undefined,
      "sections": [...populate([
  {
    id: "01-API",
    route: "/docs/css/01-API",
    title: "API Documentation",
    link: "/docs/css/01-API",
    section: "AngleSharp.Css",
    meta: {"title":"API Documentation","section":"AngleSharp.Css"},
    page: lazy(() => import('../tools/__generated__/css-01-API.tsx')),
  }, 
  {
    id: "02-Examples",
    route: "/docs/css/02-Examples",
    title: "Examples",
    link: "/docs/css/02-Examples",
    section: "AngleSharp.Css",
    meta: {"title":"Examples","section":"AngleSharp.Css"},
    page: lazy(() => import('../tools/__generated__/css-02-Examples.tsx')),
  }, 
  {
    id: "03-Questions",
    route: "/docs/css/03-Questions",
    title: "Questions",
    link: "/docs/css/03-Questions",
    section: "AngleSharp.Css",
    meta: {"title":"Questions","section":"AngleSharp.Css"},
    page: lazy(() => import('../tools/__generated__/css-03-Questions.tsx')),
  }])],
    }
  };
  const categories = Object.keys(sitemap);

  for (const category of categories) {
    const { sections } = sitemap[category];

    for (const section of sections) {
      api.registerDocumentation(section, category);
    }
  }

  api.registerSearchProvider(() => import("./search.codegen"));
};
